// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3Wu3_","content":"GlobalSearch_content__Jqn_l"};